import { Link } from 'react-router-dom';
import { Icon } from './Icon';
import { PointsPill } from './PointsPill';
import { PrimaryAction } from './PrimaryAction';
import { Challenge } from '../types';
import { paths } from '../paths';
import {
  fmtAddress,
  fmtDayMonth,
  fmtRelativeDays,
  fmtTimeRange,
} from '../utils/format';
import { nowMs } from '../utils/clock';

function statusBadge(challenge: Challenge) {
  const a = challenge.attendance;
  switch (a?.status) {
    case 'CHECKED_IN':
      return { text: 'No local · em andamento', tone: 'success' };
    case 'COMPLETED':
      return {
        text: `Concluído · +${a.pointsEarned ?? 0} pts`,
        tone: 'success',
      };
    case 'MISSED':
      return { text: 'Encerrado', tone: 'muted' };
    default:
      return {
        text: fmtRelativeDays(challenge.startsAt, nowMs()).toUpperCase(),
        tone: 'brand',
      };
  }
}

/** Card of a presence challenge in the Home list ("Para Validar"). */
export function ChallengeCard({ challenge }: { challenge: Challenge }) {
  const { day, month } = fmtDayMonth(challenge.startsAt);
  const badge = statusBadge(challenge);

  return (
    <article className="pv-card pv-challenge-card">
      <div className="pv-challenge-card__top">
        <div className="pv-date-tile" aria-hidden="true">
          <strong>{day}</strong>
          <span>{month}</span>
        </div>

        <div className="pv-challenge-card__body">
          <div className="pv-challenge-card__meta">
            <span className={`pv-badge pv-badge--${badge.tone}`}>
              {badge.text}
            </span>
            <PointsPill points={challenge.rules.maxPoints} prefix="+" />
          </div>
          <h3 className="pv-challenge-card__title">{challenge.title}</h3>
          <p className="pv-iconline">
            <Icon name="clock" size={15} />
            {fmtTimeRange(challenge.startsAt, challenge.endsAt)}
          </p>
          <p className="pv-iconline">
            <Icon name="pin" size={15} />
            {fmtAddress(challenge.location)}
          </p>
        </div>
      </div>

      <div className="pv-challenge-card__actions">
        <Link to={paths.detail(challenge.id)} className="pv-btn pv-btn--ghost">
          Ver detalhes
        </Link>
        <PrimaryAction challenge={challenge} short />
      </div>
    </article>
  );
}
